// test996
(996 && 0);
